import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { MembershipComponent } from './membership.component';

@NgModule({
	imports: [
		RouterModule,
		SharedModule,
	],
	declarations: [
		MembershipComponent,
	],
})
export class MembershipModule {
}
